var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrans12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 28,
    r: 27.5,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4998 26.6099C29.0355 26.6099 30.2803 25.365 30.2803 23.8294C30.2803 22.2937 29.0355 21.0488 27.4998 21.0488C25.9641 21.0488 24.7192 22.2937 24.7192 23.8294C24.7192 25.365 25.9641 26.6099 27.4998 26.6099Z",
    fill: "#072A30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9432 33.833V34.6691H23.0571V33.833C23.0592 33.5391 23.1741 33.2572 23.378 33.0455C23.4813 32.9424 23.6042 32.8609 23.7394 32.8058C23.8746 32.7507 24.0195 32.7231 24.1655 32.7247H30.8349C31.1294 32.7237 31.4124 32.839 31.6224 33.0455C31.8263 33.2572 31.9411 33.5391 31.9432 33.833Z",
    fill: "#072A30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0959 16.4402C35.6117 16.4413 34.151 16.0703 32.8473 15.361L27.5 12.4443L22.1528 15.361C20.8491 16.0703 19.3884 16.4413 17.9042 16.4402H13.9473V28.7777C13.9474 31.3309 14.6804 33.8305 16.059 35.9796C17.4377 38.1286 19.4043 39.8368 21.725 40.9013L27.5 43.5554L33.3334 40.9013C35.6542 39.8368 37.6207 38.1286 38.9994 35.9796C40.3781 33.8305 41.111 31.3309 41.1112 28.7777V16.4402H37.0959ZM27.5 18.8318C28.4884 18.8318 29.4546 19.1249 30.2764 19.674C31.0981 20.2231 31.7386 21.0036 32.1169 21.9167C32.4951 22.8298 32.5941 23.8346 32.4012 24.804C32.2084 25.7733 31.7325 26.6638 31.0336 27.3626C30.3347 28.0615 29.4443 28.5374 28.475 28.7303C27.5056 28.9231 26.5008 28.8241 25.5877 28.4459C24.6746 28.0677 23.8941 27.4272 23.345 26.6054C22.7959 25.7836 22.5028 24.8174 22.5028 23.8291C22.5054 22.5045 23.0327 21.2349 23.9693 20.2983C24.9059 19.3617 26.1755 18.8344 27.5 18.8318ZM34.1695 35.7777C34.167 36.0708 34.0494 36.3513 33.8421 36.5586C33.6348 36.7659 33.3543 36.8835 33.0612 36.886H21.9487C21.6538 36.886 21.3709 36.7696 21.1615 36.562C20.9521 36.3544 20.8332 36.0725 20.8306 35.7777V33.8332C20.8306 32.9488 21.1819 32.1006 21.8073 31.4752C22.4327 30.8498 23.2809 30.4985 24.1653 30.4985H30.8348C31.7192 30.4985 32.5674 30.8498 33.1928 31.4752C33.8182 32.1006 34.1695 32.9488 34.1695 33.8332V35.7777Z",
    fill: "#43D685"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrans12);
export default __webpack_public_path__ + "static/media/trans12.771a440ecbcb54eb2c621ba2a74c465b.svg";
export { ForwardRef as ReactComponent };